import http from "../http-common";
import { Form } from "../models/formModel";

class FormDataService {

  async getFormById(form: Form) {
    const json = JSON.stringify(form);
    const { data } = await http.post("/forms/id", json);
    let reduxStore = data.data;
    return reduxStore
  }

  async getFormElementsById(id: string) {
    const { data } = await http.post(`/forms/elements/${id}`);
    let elements = data.data;
    return elements
  }

  async getFormItemById(form: { id: String} ) {
    const json = JSON.stringify(form);
    return  await http.post("/forms/", json);
  }

  async getFormDetailsById(form: { id: String} ) {
    const json = JSON.stringify(form);
    const { data } = await http.post("/forms/find", json);
    return data.data
  }

  async getFormsByProjectId(form: { projectId: String, type: String} ) {
    const json = JSON.stringify(form);
    const { data } = await http.post("/forms/findByProjectId", json);
    return data.data
  }

  async createForm(form: Form) {
    const json = JSON.stringify(form);
    return await http.post("/forms/create", json);
  }

  async updateForm(form: Form) {
    const json = JSON.stringify(form);
    return await http.post("/forms/update", json);
  }

  async deleteForm(id:String) {
    // return await http.post("/forms/delete", id)
    return await http.delete(`/forms/delete/${id}`);
  }

  async copyFormPre(form: Form) {
    const json = JSON.stringify(form);
    return await http.post("/forms/copy", json);
  }

  async copyForm(saveObject : { form: Form , createBy: string , saveAs : string}) {
    const json = JSON.stringify(saveObject);
    return await http.post("/forms/saveAs", json);
  }

  async createFormDownload(request : { name: string, body: string}) {
    const json = JSON.stringify(request);
    const { data } = await http.post("/forms/downloadCreate", json);
    let path = data.data;
    return path;
  }

  async getFormDetailsByIdForPreview(id : string) {
    return await http.get(`/forms/details/${id}`);
  }
}

export default new FormDataService();